import React from 'react';
import { LoginModalProps } from '../types';
import ModalCard from './modal-card';

const LoginModal: React.FC<LoginModalProps> = ({
  isOpen,
  onClose,
  modalCards,
}) => {
  if (!isOpen) return null;

  return (
    <>
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-transparent overflow-auto wg-container lg:w-full md:w-full sm:w-full sm:overflow-x-hidden sm:overflow-y-auto opacity-100 transition-all ease-in-out delay-500 duration-300 h-3/4">
        <div className="bg-transparent w-full">
          <div
            className="text-right cursor-pointer text-white text-lg mr-3 mt-1 sm:fixed sm:top-0 sm:right-0 transition-opacity duration-300"
            onClick={onClose}
          >
            ✕
          </div>
          <div className="overflow-hidden p-4 w-full md:p-0 sm:p-0 sm:pt-3 sm:pl-3 sm:mt-3 sm:overflow-y-auto sm:h-screen">
            <div className="w-full flex justify-between items-center gap-14 sm:flex-col sm:gap-6">
              {modalCards.map((card, index) => (
                <ModalCard key={index} card={card} />
              ))}
            </div>
          </div>
        </div>
      </div>
      <div
        className="fixed inset-0 bg-black bg-opacity-75 z-40 animate-fadeIn"
        onClick={onClose}
      ></div>
    </>
  );
};

export default LoginModal;
